import { isMobile } from "../common/utils";

const initializeBrandMenu = () => {
  document.querySelectorAll(".fs-brand-grid-abc-header-item").forEach((el) => {
    el.addEventListener("click", (e) => {
      const title = e.target.dataset.title;
      const mode = e.target.dataset.mode;
      const target = document.querySelector(`.fs-brand-grid-item[data-title="${title}"`);
      const targetRect = target.getBoundingClientRect();
      const headerBarBottom = getComputedStyle(document.documentElement)
        .getPropertyValue("--fs-header-bar-bottom")
        .trim();
      const top = targetRect.top + window.scrollY - parseFloat(headerBarBottom) - (isMobile() ? 72 : 48) - 52;
      window.scrollTo({ top: top, behavior: "smooth" });
    });
  });
};

document.addEventListener("DOMContentLoaded", () => {
  initializeBrandMenu();
});
